import whyDidYouRender from '@welldone-software/why-did-you-render';
import { NodeEnv } from 'gleblu-socket-api';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './app/App';
import initializeLogger from './logging/logger';
import registerServiceWorker from './registerServiceWorker';

if (import.meta.env.MODE === NodeEnv.development) {
  whyDidYouRender(React, { include: [] });
}

const container = document.getElementById('root');
if (container === null) throw new Error('Cannot get root element to render the App to');
const root = createRoot(container);
root.render(<App />);

registerServiceWorker();
initializeLogger();
